import type { CommandBarAction, CommandBarActionInput } from './types'

/**
 * Helper to create a command bar action with computed displayName.
 *
 * @param input - Action configuration (displayName is auto-computed if not provided)
 * @returns A fully-formed CommandBarAction with defaults applied
 */
export function createAction(input: CommandBarActionInput): CommandBarAction {
  const displayName =
    input.displayName ??
    (input.prefix ? `${input.prefix} → ${input.name}` : input.name)

  // Pre-compute search tokens for performance
  const searchTokens = displayName.toLowerCase().split(/\s+/)

  return {
    ...input,
    displayName,
    searchTokens,
    context: input.context ?? ['global'],
    priority: input.priority ?? 0,
    excludeFromFrecency: input.excludeFromFrecency ?? false,
  }
}
